import React, {ReactText} from 'react';
import styled from 'styled-components';

export interface StyledGradientViewProps {
  colors: ReactText[];
  rotation?: string;
  mirrored?: boolean;
}

const StyledGradientView = styled.div<StyledGradientViewProps>`
  background: ${({colors, rotation = '180deg', mirrored = false}) =>
    mirrored
      ? 'linear-gradient(' +
        rotation +
        ',' +
        colors[0] +
        ' 0%,' +
        colors[1] +
        ' 50%,' +
        colors[0] +
        ' 100%)'
      : 'linear-gradient(' +
        rotation +
        ',' +
        colors[0] +
        ' 0%,' +
        colors[1] +
        ' 100%)'}}
    
    
`;

export interface LinearGradientProps {
  colors: ReactText[];
  mirrored?: boolean;
  rotation?: string;
  children?: React.ReactNode;
}

const LinearGradient: React.FC<LinearGradientProps> = props => {
  const {colors, mirrored = false, rotation, children} = props;

  return (
    <StyledGradientView colors={colors} mirrored={mirrored} rotation={rotation}>
      {children}
    </StyledGradientView>
  );
};

export default LinearGradient;
